var map = {
	"./tech-responsive-apache-airflow.svg": 615,
	"./tech-responsive-artificial-intelligence.svg": 548,
	"./tech-responsive-azure.svg": 616,
	"./tech-responsive-chatgpt.svg": 617,
	"./tech-responsive-copilot.svg": 618,
	"./tech-responsive-data.svg": 619,
	"./tech-responsive-excel.svg": 620,
	"./tech-responsive-git.svg": 621,
	"./tech-responsive-google-cloud.svg": 622,
	"./tech-responsive-google-sheets.svg": 623,
	"./tech-responsive-hugging-face.svg": 624,
	"./tech-responsive-jupyter.svg": 625,
	"./tech-responsive-langchain.svg": 626,
	"./tech-responsive-llama.svg": 627,
	"./tech-responsive-multiple.svg": 628,
	"./tech-responsive-powerbi.svg": 629,
	"./tech-responsive-powerpoint.svg": 630,
	"./tech-responsive-python.svg": 631,
	"./tech-responsive-r.svg": 632,
	"./tech-responsive-shell.svg": 633,
	"./tech-responsive-sql.svg": 634,
	"./tech-responsive-tableau.svg": 635,
	"./tech-responsive-theory.svg": 636
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 527;